module.exports = {template: '<svg width="80" height="80" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg"><path d="M37.468 0v6.076h-6.076v6.075h-6.075v6.077H19.24v6.076h-6.075v6.076H7.088v6.075H0v6.076h7.088v6.076h6.077v6.077h6.075v6.075h6.077v6.076h6.075v6.076h6.076V80h6.076v-7.089h6.076v-6.076h6.076v-6.076h6.077v-6.075h6.076v-6.077h6.075v-6.076H80v-6.076h-6.076V30.38H67.85v-6.076h-6.076v-6.076h-6.077V12.15H49.62V6.076h-6.076V0z" fill="#F8008E" fill-rule="evenodd"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./static/svg/raw/enews_diamondshape.svg
// module id = 1110
// module chunks = 1 2 3